import React, { Suspense, useEffect, useState } from "react";
// HOOKS
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";

// PAGES
import Matriz from "./Matriz/Matriz";
import MatrizLanding from "./MatrizLanding/MatrizLanding";
import Simulador from "./Simulador/Simulador";

// COMPONENTS
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenu/FilterMenu";
import Header from "../components/Header/Header";

// ASSETS
// import logo from '../assets/logo.png';
import logo from "../assets/icons/logo.svg";
import "../style.scss";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import MiddlewareRoute from "../components/MiddlewareRoute";
import Auth from "./auth";
import Logout from "./auth/Logout";
import Evolution from "./Evolution/Evolution";
import { TourProvider } from "@reactour/tour";
import TutorialModal from "../components/Tutorial/Tutorial";
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";
import TutorialWrapper from "../components/Tutorial/TutorialWrapper";

function LayoutPage() {
  const { qlik, qlikConfig, setActualApp, switchOnDemand } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isA, setIsA] = useState(switchOnDemand);
  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);

      // Config App OnDemand
    }
  }, [qlik]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [filterBarOpened, leftBarOpened]);

  useEffect(() => {
    console.log("Proxima rota", switchOnDemand);
    setIsA(switchOnDemand);
  }, [switchOnDemand]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <TutorialWrapper>
          <LeftSideMenu app={app} config={config} logo={logo} />
          <Header />
          <FilterMenu
            app={app}
            config={config}
            filters={config.app?.filters || {}}
          />
          <Switch>
            <Route path="/auth" render={() => <Auth />} />
            <Route path="/redirect" render={() => <Logout />} />
            <Route
              path="/logout"
              render={() => <MiddlewareRoute component={<Logout />} publico />}
            />
            <Route
              path="/matriz-landing-test"
              exact
              render={() => (
                <MiddlewareRoute
                  component={<Matriz app={app} config={config} />}
                  container
                />
              )}
            />
            <Route
              path="/matriz"
              exact
              render={() => (
                <MiddlewareRoute
                  component={<MatrizLanding app={app} config={config} />}
                  container
                />
              )}
            />
            <Route exact path="/">
              <Redirect to="/matriz" />
            </Route>
            <Route
              path="/simulador"
              exact
              render={() => (
                <MiddlewareRoute
                  component={<Simulador app={app} config={config} />}
                  container
                />
              )}
            />
            <Route
              path="/evolution"
              exact
              render={() => (
                <MiddlewareRoute
                  component={<Evolution app={app} config={config} />}
                  container
                />
              )}
            />
          </Switch>
        </TutorialWrapper>
      </HashRouter>
    </div>
  );
}

export default function Layout() {
  return (
    <Suspense fallback={<AppLoader />}>
      <I18nextProvider i18n={i18n}>
        <LayoutPage />
      </I18nextProvider>
    </Suspense>
  );
}
